import { useState, useEffect } from "react";
import moment from "moment";
import { Table, Form, Dropdown } from "semantic-ui-react";
import "./tvList.css";
import { frenchLanguage } from "./localeTime";
import Footer from "./Footer";
import { useQuery } from "react-query";
import { getData } from "../../Components/Api/api";
import GenericTable from "./GenericTable";
import { socket, server } from "../../App";
import useGetDoctorsSemanticUI from "../../CustomHooks/useGetDoctorsSemanticUI"
import axios from "axios";

function TvList(props) {
  const [clockAndDay, setclockAndDay] = useState("");
  const [medecin, setmedecin] = useState(3);
  const { logout } = props;
  const listeMedecin = useGetDoctorsSemanticUI()

  const date = moment().format("YYYY-MM-DD");

  const GetAnnonces = () => {
    let url = `${server}products/GetAnnonces`;

    return axios.get(url, {
      headers: {
        jwtoken: sessionStorage.token,
      },
    });
  };


  const { data: annonces } = useQuery("GetAnnonces", () => {
    return GetAnnonces();
  });

  let texte_du_client = annonces?.data[0]

  const { data, refetch } = useQuery("liste_dattente", () => {
    return getData(date, medecin);
  });

  useEffect(() => {
    refetch();


  }, [medecin])


  useEffect(() => {
    frenchLanguage();
  }, []);

  useEffect(() => {
    function receivedMessage(m) {
      refetch();
    }

    socket.on("add", receivedMessage);
    socket.on("update", receivedMessage);
    socket.on("transfer", receivedMessage);
    return () => {
      socket.off("add", receivedMessage);
      socket.off("update", receivedMessage);
      socket.off("transfer", receivedMessage);
    };
    // eslint-disable-next-line
  }, []);

  let bigContainner;
  let users;
  let users1;
  let users2;

  users = data
    ?.slice(0, 19)
    .map((user, i) => <GenericTable key={Math.random()} i={i} user={user} increment={1} />);

  users1 = data
    ?.slice(19, 37)
    .map((user, i) => <GenericTable key={Math.random()} i={i} user={user} increment={20} />);

  users2 = data
    ?.slice(37, 57)
    .map((user, i) => <GenericTable key={Math.random()} i={i} user={user} increment={38} />);

  let condition = data?.length;
  if (condition > 0) {
    bigContainner = (
      <>

        <Table singleLine className="holder">

          <Table.Body className="WaitingListElements">{users}</Table.Body>
          <Table.Body className="WaitingListElements">{users1}</Table.Body>
          <Table.Body className="WaitingListElements">{users2}</Table.Body>
        </Table>

        <Form.Field
          className="foreground2"
          value={medecin}
          // search
          selection
          // fluid
          // label="Année"
          control={Dropdown}
          options={listeMedecin?.Doctors_list ? listeMedecin?.Doctors_list : []}
          // placeholder="Select Doctor"
          onChange={(e, data) => {
            setmedecin(data.value);
          }}
        />
        <Footer logout={logout} texte_du_client={texte_du_client} />
      </>
    );
  } else {
    bigContainner = (
      <>
        <div className="holderOfElements">
          <div></div>
          <p className="messageAcceuil">
            Bienvenue au centre d'ophtalmologie Al Badr
          </p>
          <div></div>
          <div></div>
          <p className="messageAcceuilMiddle">{clockAndDay}</p>
          <div></div>
          <div></div>
        </div>
        <Footer logout={logout} texte_du_client={texte_du_client} />
        <Form.Field
          className="foreground2"
          value={medecin}
          // search
          selection
          // fluid
          // label="Année"
          control={Dropdown}
          options={listeMedecin?.Doctors_list ? listeMedecin?.Doctors_list : []}
          // placeholder="Select Doctor"
          onChange={(e, data) => {
            setmedecin(data.value);
          }}
        />
        {/* <Footer logout={logout} /> */}

      </>
    );
  }
  useEffect(() => {
    let myInterval = setInterval(() => {
      timeFunc();
    }, 60000);

    return () => {
      clearInterval(myInterval);
    };
  }, [clockAndDay]);

  function timeFunc() {
    let time = moment().format("LLLL");
    setclockAndDay(time);
  }
  return <div className="containerMODTV">{bigContainner}</div>;
}

export default TvList;
